import React, { memo, forwardRef, useContext, useImperativeHandle } from 'react';
import cn from 'classnames';
import { usePreventScroll } from '@react-aria/overlays';
import { Box } from '../box';
import { ModalContext } from './contexts';
import styles from './modal.module.css';
export const ModalContainer = memo(forwardRef(function ModalContainer({ children, className, preventScroll, ...props }, ref) {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error('Modal component has to be placed inside Modal.Overlay');
    }
    const { modalProps: { size, ...modalProps }, } = context;
    useImperativeHandle(ref, () => modalProps.ref.current);
    usePreventScroll({ isDisabled: preventScroll === false });
    return (React.createElement(Box, { className: cn(className, styles.modal), ...modalProps, ...props }, children));
}));
